
// import React, { useEffect, useState } from "react";
// import { NavLink } from "react-router-dom";
// import { FaFacebookF, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";

// import bslogo from "./assets/companylogo.png";
// import ThreeD from "./ThreeD";
// import image1 from "./assets/opimage1.png";
// import image2 from "./assets/opimage2.png";
// import image3 from "./assets/opimage3.png";
// import image4 from "./assets/opimage4.png";
// import image5 from "./assets/opimage5.png";
// import image6 from "./assets/opimage6.png";
// import image8 from "./assets/opimage8.png";
// import image9 from "./assets/opimage9.png";

// const PROJECTS = [
//   {
//     id: "01",
//     name: "CM Cheyutha",
//     domain: "Government Services",
//     type: "Mobile Application",
//     image: image1,
//     description:
//       "CM Cheyutha is a large-scale citizen-services platform built to meet AP and Telangana Government requirements. It lets citizens raise problems, report crimes, and file grievances through dedicated pages, then track each request to resolution. The app runs MLA and MP perception surveys to capture public feedback at the constituency level. Residents can browse government services, view bills, and complete payments inside a single secure flow. A powerful admin layer gives officials live monitoring, status updates, and reporting. The result is a transparent bridge between citizens and the government that reduces paperwork, speeds up responses, and keeps every interaction accountable from submission to closure.",
//     tags: ["Grievance Portal", "Surveys", "Bills & Payments", "Admin Monitoring"],
//   },
//   {
//     id: "02",
//     name: "Employee Desk (HRMS)",
//     domain: "HR & Employee Management",
//     type: "Mobile Application",
//     image: image2,
//     description:
//       "Employee Desk is a complete HRMS that brings every people-operation into one connected workspace. It maintains accurate employee records, tracks daily attendance, and manages the full leave lifecycle from request to approval. Multi-level approval chains keep managers and HR aligned, while built-in internal communication keeps teams informed without scattered emails. Detailed reports turn raw activity into insight on attendance trends, leave balances, and workforce performance. Role-based access ensures employees, managers, and HR each see exactly what they need. By replacing spreadsheets and manual registers with a structured digital system, Employee Desk cuts administrative overhead and helps organisations run their HR and admin operations smoothly and reliably.",
//     tags: ["Attendance", "Leave Management", "Approvals", "Reports"],
//   },
//   {
//     id: "03",
//     name: "Bizvora · Naarisamman · CityChoice Mart",
//     domain: "E-Commerce / Marketplace",
//     type: "Mobile + Web",
//     image: image3,
//     description:
//       "This is a family of full-featured online shopping platforms delivered for multiple brands. Each storefront offers rich product listings organised into clear categories, making it easy for shoppers to discover what they need. A smooth cart and checkout flow handles orders end to end, while customer management keeps profiles, addresses, and history in order. Dedicated vendor and admin panels let sellers manage inventory and let operators oversee the whole marketplace. Promotional offers and discounts drive engagement, and live order tracking keeps buyers informed after purchase. Together these apps give each brand a scalable, branded commerce experience that supports growth from a handful of products to a busy multi-vendor catalog.",
//     tags: ["Catalog", "Cart & Orders", "Vendor Panel", "Order Tracking"],
//     // websites: [
//     //   { label: "Bizvora", url: "https://www.google.com/search?q=bizvora" },
//     //   { label: "Naarisamman", url: "https://www.google.com/search?q=naarisamman" }
//     // ]
//   },
//   {
//     id: "04",
//     name: "Trace My Bus",
//     domain: "Transport / School Bus Tracking",
//     type: "Mobile Application",
//     image: image4,
//     description:
//       "Trace My Bus is a real-time tracking solution built for schools and private fleet-management teams. Parents and administrators can follow each bus on a live map, see its position along the assigned route, and know when it will arrive. Route monitoring flags delays and deviations early, while driver details add a layer of trust and accountability for every trip. The platform is designed around student safety, giving schools a clear record of who is on board and where the vehicle is at all times. A central admin console manages routes, drivers, and vehicles in one place. The outcome is calmer mornings, fewer anxious calls, and safer journeys for every student.",
//     tags: ["Live Location", "Route Monitoring", "Driver Details", "Student Safety"],
//   },
//   {
//     id: "05",
//     name: "MediQueue & Hospital Management System",
//     domain: "Healthcare",
//     type: "Mobile Application",
//     image: image5,
//     description:
//       "MediQueue and the companion Hospital Management System digitise the everyday running of clinics and hospitals. Patients can book appointments or tokens, check doctor timings, and avoid long waits thanks to smart queue management. Comprehensive patient records keep medical history, visits, and prescriptions organised and accessible to authorised staff. The administration layer handles departments, schedules, and day-to-day hospital operations from one dashboard. Automated notifications remind patients of appointments and keep them updated, reducing no-shows. Detailed reports support better decisions on capacity and care. By replacing manual registers and crowded waiting rooms with an orderly digital flow, these apps improve the experience for patients while giving healthcare teams the control and visibility they need.",
//     tags: ["Appointments", "Queue Management", "Patient Records", "Notifications"],
//   },
//   {
//     id: "06",
//     name: "Gated Community & All-in-One Services",
//     domain: "Community / Services",
//     type: "Mobile Application",
//     image: image6,
//     description:
//       "This suite of apps modernises life in residential communities and apartment complexes. Visitor management screens and logs every guest, strengthening security at the gate. Residents can raise complaints, submit repair requests, and book everyday services without chasing anyone in person. Integrated payments make maintenance dues and service charges simple to settle online. Security and admin teams get dedicated tools to coordinate staff, track requests, and keep the community running smoothly. Notifications keep everyone informed about announcements and approvals. By combining visitor control, service bookings, complaints, and payments into one all-in-one platform, these apps reduce friction for residents and give management a clear, accountable view of every activity inside the community.",
//     tags: ["Visitor Management", "Complaints", "Service Booking", "Security"],
//   },
//   {
//     id: "07",
//     name: "Trust, Church & Mission Apps",
//     domain: "Service-Oriented Platforms",
//     type: "Mobile + Web",
//     image: "https://images.unsplash.com/photo-1438032005730-c779502df39b?auto=format&fit=crop&w=900&q=80",
//     description:
//       "Built for religious, trust, and mission-based organisations such as Bible apps, Swamy Vivekananda Mission Trust, and Delight Christian Church, these platforms keep communities connected. Administrators can publish content updates and share devotional or organisational material with members instantly. An events module announces gatherings and programmes, while a gallery preserves photos and memories from each occasion. Push notifications keep members informed about news and schedules. Secure donation features let supporters contribute easily and transparently. Member communication tools strengthen the bond between the organisation and its community. By bringing content, events, donations, and messaging into one respectful, easy-to-use app, these solutions help mission-driven organisations grow their reach and serve their members with care.",
//     tags: ["Content Updates", "Events", "Gallery", "Donations"],
//     websites: [
//       { label: "Vivekananda Mission Trust", url: "https://vivekanandamissiontrust.com/" },
//       { label: "Church Portal", url: "https://divinelightchristianassemblychurch.com/" }
//     ]
//   },
//   {
//     id: "08",
//     name: "Real Estate Project",
//     domain: "Real Estate / Property Management",
//     type: "Mobile + Web",
//     image: image8,
//     description:
//       "This real-estate solution covers the entire property journey for developers and agencies. It presents ventures and projects with detailed listings, layouts, and plot or flat information so buyers can explore options clearly. Prospects can schedule site visits and move into bookings without losing momentum. Payment tracking keeps every instalment and milestone transparent for both customer and company. Customer management organises leads and clients, while employee roles assign the right access to sales and support staff. Comprehensive admin dashboards give leadership a real-time view of inventory, bookings, and revenue. By unifying listings, visits, bookings, payments, and reporting, the platform streamlines sales and brings order and confidence to property transactions.",
//     tags: ["Listings", "Site Visits", "Bookings", "Dashboards"],
//   },
//   {
//     id: "09",
//     name: "Matrimony — All & Christian Community",
//     domain: "Matrimony / Community Platform",
//     type: "Mobile Application",
//     image: image9,
//     description:
//       "These matrimony platforms serve both all-community and Christian-community users with a safe, structured path to finding a life partner. Members create detailed profiles and use powerful search and match features to discover compatible candidates. Interest requests let users express intent respectfully, while admin approval keeps the community trustworthy and free of fake profiles. Built-in chat and contact controls protect privacy until both sides are comfortable connecting. Clear membership workflows guide users from registration through to premium plans. Administrators oversee verification, approvals, and member activity from a central panel. By balancing rich matching tools with careful moderation and privacy, these apps deliver a dignified, community-focused matrimony experience that families can rely on.",
//     tags: ["Profiles", "Search & Match", "Interest Requests", "Membership"],
//   },
// ];

// function OurProjects() {
//   const [navScrolled, setNavScrolled] = useState(false);
//   const [activeId, setActiveId] = useState(null);
//   const [menuOpen, setMenuOpen] = useState(false);

//   useEffect(() => {
//     const onScroll = () => setNavScrolled(window.scrollY > 60);
//     window.addEventListener("scroll", onScroll, { passive: true });
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   useEffect(() => {
//     const revealTargets = document.querySelectorAll(".reveal-up, .reveal-left, .reveal-right");
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) entry.target.classList.add("visible");
//         });
//       },
//       { threshold: 0.12 }
//     );
//     revealTargets.forEach((el) => observer.observe(el));
//     return () => observer.disconnect();
//   }, []);

//   return (
//     <div className="projects-page">
//       <style>{`
//         * { box-sizing: border-box; margin: 0; padding: 0; }
//         :root {
//           --accent: #a3e635;
//           --accent-2: #bef264;
//           --accent-deep: #84cc16;
//           --text-main: #eef2f7;
//           --text-soft: #94a3b8;
//           --heading-font: "Cinzel", serif;
//           --body-font: "Manrope", sans-serif;
//         }
//         html, body { cursor: auto !important; }
//         input, textarea { cursor: text !important; caret-color: #a3e635; }
//         button, a, select { cursor: pointer !important; }
//         html { scroll-behavior: smooth; }
//         body { font-family: var(--body-font); color: var(--text-main); background: #0a0e1a; }

//         .projects-page { position: relative; min-height: 100vh; overflow: hidden; }

//         /* NAVBAR */
//         .projects-navbar {
//           position: sticky;
//           top: 0;
//           z-index: 1000;
//           background: rgba(19, 26, 44, 0.88);
//           backdrop-filter: blur(16px);
//           border-bottom: 1px solid rgba(163, 230, 53,0.12);
//           box-shadow: 0 8px 28px rgba(15,23,42,0.05);
//           transition: box-shadow 0.4s ease, background 0.4s ease;
//           will-change: background, box-shadow;
//           transform: translateZ(0);
//         }
//         .projects-navbar.scrolled { background: rgba(19, 26, 44, 0.98); box-shadow: 0 12px 40px rgba(15,23,42,0.14); }

//         .projects-nav-container {
//           width: min(1220px, 92%);
//           margin: 0 auto;
//           padding: 14px 0;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .projects-nav-logo {
//           display: flex;
//           align-items: center;
//           gap: 14px;
//         }

//         .projects-nav-logo img {
//           width: 54px;
//           height: 54px;
//           object-fit: contain;
//           border-radius: 14px;
//         }

//         .projects-site-title {
//           font-family: var(--heading-font);
//           font-size: 1.45rem;
//           font-weight: 800;
//           letter-spacing: 1px;
//           color: #eef2f7;
//         }

//         .projects-back-button {
//           width: 42px;
//           height: 42px;
//           border-radius: 50%;
//           border: none;
//           background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
//           color: #fff;
//           font-size: 18px;
//           cursor: pointer;
//           box-shadow: 0 10px 24px rgba(163, 230, 53,0.22);
//           transition: transform 0.3s ease, box-shadow 0.3s ease;
//         }

//         .projects-back-button:hover {
//           transform: scale(1.12);
//           box-shadow: 0 18px 38px rgba(163, 230, 53,0.35);
//         }

//         .projects-nav-links {
//           display: flex;
//           align-items: center;
//           gap: 22px;
//         }

//         .projects-nav-links a {
//           color: var(--text-soft);
//           font-size: 0.96rem;
//           font-weight: 700;
//           text-decoration: none;
//           transition: color 0.28s ease;
//         }

//         .projects-nav-links a:hover,
//         .projects-nav-links a.active { color: var(--accent-deep); }

//         .projects-nav-toggle {
//           display: none;
//           font-size: 1.8rem;
//           color: #eef2f7;
//           cursor: pointer;
//         }

//         /* HERO SECTION */
//         .projects-hero {
//           background: linear-gradient(135deg, rgba(163, 230, 53,0.1), rgba(163, 230, 53, 0.05));
//           display: grid;
//           place-items: center;
//           text-align: center;
//           padding: 70px 5% 50px;
//         }

//         .projects-hero-content h1 {
//           font-family: var(--heading-font);
//           font-size: clamp(2rem, 5vw, 3.5rem);
//           color: var(--text-main);
//           margin-bottom: 20px;
//           letter-spacing: 1px;
//           animation: slideInDown 0.8s ease-out;
//         }

//         .projects-hero-content p {
//           font-size: 1.1rem;
//           color: var(--text-soft);
//           max-width: 760px;
//           margin: 0 auto;
//           line-height: 1.8;
//           animation: fadeIn 0.8s ease-out 0.2s both;
//         }

//         /* DOMAIN CHIPS */
//         .projects-domain-strip {
//           width: min(1220px, 92%);
//           margin: 0 auto 10px;
//           display: flex;
//           flex-wrap: wrap;
//           gap: 10px;
//           justify-content: center;
//           padding-bottom: 30px;
//         }

//         .projects-domain-chip {
//           padding: 8px 18px;
//           border-radius: 999px;
//           background: rgba(163, 230, 53,0.07);
//           border: 1px solid rgba(163, 230, 53,0.18);
//           color: var(--accent-deep);
//           font-size: 0.85rem;
//           font-weight: 700;
//           animation: slideUp 0.5s ease-out;
//           transition: all 0.3s ease;
//           cursor: pointer;
//         }

//         .projects-domain-chip:hover {
//           background: rgba(163, 230, 53,0.15);
//           border-color: var(--accent-deep);
//           transform: translateY(-2px);
//         }

//         .projects-domain-chip.active {
//           background: var(--accent-deep);
//           border-color: var(--accent-deep);
//           color: #0a0e1a;
//           box-shadow: 0 8px 20px rgba(163, 230, 53,0.3);
//         }

//         /* ALTERNATING PROJECTS SECTION */
//         .projects-container {
//           width: min(1220px, 92%);
//           margin: 30px auto 90px;
//         }

//         .project-section {
//           margin-bottom: 80px;
//           animation: fadeIn 0.8s ease-out;
//           border: 1px solid rgba(163, 230, 53,0.18);
//           border-radius: 26px;
//           padding: 30px;
//           background: #0a0e1a;
//           transition: border-color 0.4s ease, box-shadow 0.4s ease;
//           scroll-margin-top: 110px;
//         }

//         .project-section:hover {
//           border-color: rgba(163, 230, 53,0.4);
//           box-shadow: 0 16px 40px rgba(163, 230, 53,0.1);
//         }

//         .project-section.active {
//           border-color: var(--accent-deep);
//           box-shadow: 0 16px 40px rgba(163, 230, 53,0.18);
//         }

//         .project-section-inner {
//           display: grid;
//           grid-template-columns: 1.5fr 1fr;
//           gap: 60px;
//           align-items: center;
//         }

//         /* IMAGE COLUMN */
//         .project-image-column {
//           position: relative;
//           overflow: hidden;
//           border-radius: 22px;
//           height: 410px;
//         }

//         .project-image-column img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//           transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
//         }

//         .project-section:hover .project-image-column img {
          
//         }

//         .project-image-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(0,0,0,0);
//           transition: background 0.4s ease;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 20px;
//         }

//         .project-section.active .project-image-overlay {
//           background: rgba(163, 230, 53,0.15);
//         }

//         .project-type-badge {
//           position: absolute;
//           bottom: 20px;
//           right: 20px;
//           background: var(--accent);
//           color: #fff;
//           font-size: 0.8rem;
//           font-weight: 700;
//           padding: 8px 16px;
//           border-radius: 999px;
//           z-index: 2;
//           box-shadow: 0 8px 20px rgba(163, 230, 53,0.3);
//         }

//         /* CONTENT COLUMN */
//         .project-content-column {
//           display: flex;
//           flex-direction: column;
//           gap: 16px;
//           padding: 40px;
//           background: #131a2c;
//           border-radius: 22px;
//           transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
//           cursor: pointer;
//           border: 2px solid transparent;
//         }

//         .project-section.active .project-content-column {
//           background: linear-gradient(135deg, rgba(163, 230, 53,0.08), rgba(163, 230, 53, 0.04));
//           border: 2px solid var(--accent);
//           box-shadow: 0 0 0 12px rgba(163, 230, 53,0.08), 0 20px 50px rgba(163, 230, 53,0.15);
//           transform: scale(1.02);
//         }

//         .project-content-column:hover {
//           transform: translateY(-4px);
//         }

//         .project-section.active .project-content-column:hover {
//           transform: scale(1.02) translateY(-4px);
//         }

//         .project-domain-label {
//           font-size: 0.8rem;
//           font-weight: 800;
//           letter-spacing: 1.2px;
//           color: var(--accent-deep);
//           text-transform: uppercase;
//           margin-bottom: 8px;
//         }

//         .project-title {
//           font-family: var(--heading-font);
//           font-size: 1.8rem;
//           color: var(--text-main);
//           line-height: 1.3;
//           margin-bottom: 12px;
//         }

//         .project-title::after {
//           content: "";
//           display: block;
//           width: 48px;
//           height: 4px;
//           background: linear-gradient(90deg, var(--accent), var(--accent-2));
//           border-radius: 3px;
//           margin-top: 10px;
//         }

//         .project-description {
//           font-size: 1rem;
//           color: var(--text-soft);
//           line-height: 1.8;
//           margin-bottom: 12px;
//           max-height: 200px;
//           overflow: hidden;
//           transition: max-height 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
//         }

//         .project-section.active .project-description {
//           max-height: 1000px;
//         }

//         .project-tags {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 8px;
//           margin-top: 16px;
//         }

//         .project-tag {
//           font-size: 0.75rem;
//           font-weight: 600;
//           color: var(--accent-deep);
//           background: rgba(163, 230, 53,0.1);
//           padding: 6px 14px;
//           border-radius: 999px;
//           transition: all 0.3s ease;
//           border: 1px solid rgba(163, 230, 53,0.2);
//         }

//         .project-tag:hover {
//           background: rgba(163, 230, 53,0.2);
//           border-color: var(--accent-deep);
//           transform: translateY(-2px);
//         }

//         .project-toggle-btn {
//           align-self: flex-start;
//           margin-top: auto;
//           background: none;
//           border: none;
//           color: var(--accent-deep);
//           font-weight: 800;
//           font-size: 0.95rem;
//           cursor: pointer;
//           padding: 0;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           transition: all 0.3s ease;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }

//         .project-toggle-btn:hover {
//           color: var(--accent);
//           transform: translateX(4px);
//         }

//         .project-toggle-arrow {
//           display: inline-block;
//           transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
//           font-size: 1.2rem;
//         }

//         .project-section.active .project-toggle-arrow {
//           transform: rotate(-180deg);
//         }

//         /* VISIT WEBSITE BUTTON */
//         .project-websites-container {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 12px;
//           margin-top: 12px;
//         }

//         .project-visit-btn {
//           align-self: flex-start;
//           background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
//           border: none;
//           color: #fff;
//           font-weight: 700;
//           font-size: 0.85rem;
//           cursor: pointer;
//           padding: 10px 20px;
//           border-radius: 999px;
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           text-decoration: none;
//           box-shadow: 0 6px 16px rgba(163, 230, 53,0.25);
//         }

//         .project-visit-btn:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 12px 24px rgba(163, 230, 53,0.35);
//         }

//         .project-visit-btn svg {
//           width: 14px;
//           height: 14px;
//         }

//         /* REVERSE LAYOUT */
//         .project-section-inner.reverse {
//           direction: rtl;
//         }

//         .project-section-inner.reverse > * {
//           direction: ltr;
//         }

//         /* CTA STRIP */
//         .projects-cta-strip {
//           width: min(1220px, 92%);
//           margin: 0 auto 90px;
//           background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
//           border-radius: 26px;
//           padding: 50px 5%;
//           text-align: center;
//           color: white;
//           animation: slideUp 0.8s ease-out;
//         }

//         .projects-cta-strip h2 {
//           font-family: var(--heading-font);
//           font-size: clamp(1.5rem, 3vw, 2.2rem);
//           margin-bottom: 14px;
//         }

//         .projects-cta-strip p {
//           font-size: 1rem;
//           opacity: 0.92;
//           max-width: 560px;
//           margin: 0 auto 26px;
//           line-height: 1.7;
//         }

//         .projects-cta-btn {
//           display: inline-block;
//           padding: 14px 38px;
//           background: #0a0e1a;
//           color: var(--accent-deep);
//           border-radius: 999px;
//           font-weight: 800;
//           text-decoration: none;
//           transition: transform 0.3s ease, box-shadow 0.3s ease;
//           border: none;
//           cursor: pointer;
//           font-size: 0.95rem;
//         }

//         .projects-cta-btn:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 16px 36px rgba(0,0,0,0.25);
//         }

//         /* FOOTER */
//         .tunga-footer {
//           background: linear-gradient(180deg, rgba(163, 230, 53, 0.08), #070a12 18%);
//           color: white;
//           padding: 60px 5%;
//           margin-top: 0;
//           border-top: 3px solid var(--accent);
//         }

//         .tunga-footer-content {
//           width: min(1220px, 92%);
//           margin: 0 auto;
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 50px;
//           margin-bottom: 40px;
//         }

//         .tunga-footer-col h3 {
//           font-family: var(--heading-font);
//           font-size: 1.3rem;
//           margin-bottom: 20px;
//           color: var(--accent-2);
//         }

//         .tunga-footer-col p, .tunga-footer-col a {
//           font-size: 0.95rem;
//           line-height: 1.8;
//           color: rgba(255,255,255,0.8);
//           text-decoration: none;
//         }

//         .tunga-footer-col a:hover { color: var(--accent-2); }

//         .tunga-social-links {
//           display: flex;
//           gap: 12px;
//           margin-top: 20px;
//         }

//         .tunga-social-links a {
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: rgba(163, 230, 53,0.2);
//           display: grid;
//           place-items: center;
//           transition: all 0.3s ease;
//           color: var(--accent-2);
//         }

//         .tunga-social-links a:hover {
//           background: var(--accent);
//           color: white;
//           transform: translateY(-4px);
//         }

//         /* ANIMATIONS */
//         @keyframes slideInDown {
//           from {
//             opacity: 0;
//             transform: translateY(-30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes slideUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }

//         .reveal-up {
//           opacity: 0;
//           transform: translateY(40px);
//           animation: slideUp 0.8s ease-out forwards;
//         }

//         .reveal-left {
//           opacity: 0;
//           transform: translateX(-40px);
//           animation: slideInLeft 0.8s ease-out forwards;
//         }

//         .reveal-right {
//           opacity: 0;
//           transform: translateX(40px);
//           animation: slideInRight 0.8s ease-out forwards;
//         }

//         @keyframes slideInLeft {
//           to { opacity: 1; transform: translateX(0); }
//         }

//         @keyframes slideInRight {
//           to { opacity: 1; transform: translateX(0); }
//         }

//         /* MOBILE RESPONSIVE */
//         @media (max-width: 768px) {
//           .projects-nav-toggle { display: block; }
//           .projects-nav-links {
//             position: absolute;
//             top: 82px; right: 4%;
//             width: 240px;
//             display: none;
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 16px;
//             padding: 20px;
//             background: rgba(19, 26, 44, 0.98);
//             border-radius: 18px;
//             border: 1px solid rgba(163, 230, 53,0.14);
//             box-shadow: 0 18px 40px rgba(15,23,42,0.12);
//           }
//           .projects-nav-links.active { display: flex; }
          
//           .project-section-inner {
//             grid-template-columns: 1fr;
//             gap: 30px;
//           }

//           .project-section-inner.reverse {
//             direction: ltr;
//           }

//           .project-image-column {
//             height: 280px;
//           }

//           .project-content-column {
//             padding: 30px 20px;
//           }

//           .project-title {
//             font-size: 1.4rem;
//           }

//           .projects-cta-strip { padding: 40px 6%; }

//           .project-section {
//             margin-bottom: 50px;
//             padding: 18px;
//           }
//         }
//       `}</style>

//       <ThreeD />

//       {/* NAVBAR */}
//       <header className={`projects-navbar${navScrolled ? " scrolled" : ""}`}>
//         <div className="projects-nav-container">
//           <div className="projects-nav-logo">
          
//             <h1 className="projects-site-title">Our Projects</h1>
//           </div>
//           <div className="projects-nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
//             ☰
//           </div>

//           <nav className={`projects-nav-links${menuOpen ? " active" : ""}`}>
//             <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
//             <NavLink to="/Tunga-Drones" onClick={() => setMenuOpen(false)}>Tunga Drones</NavLink>
//             <NavLink to="/Our-Projects" onClick={() => setMenuOpen(false)}>Our Projects</NavLink>
//             <NavLink to="/Services" onClick={() => setMenuOpen(false)}>Services</NavLink>
//             <NavLink to="/Careers" onClick={() => setMenuOpen(false)}>Careers</NavLink>
//             <NavLink to="/OurTeam" onClick={() => setMenuOpen(false)}>Our Core Team</NavLink>
//           </nav>
//         </div>
//       </header>

//       {/* HERO */}
//       <section className="projects-hero reveal-up">
//         <div className="projects-hero-content">
//           <h1>Our Projects</h1>
//           <p>
//             A showcase of platforms we've built across government services, healthcare, e-commerce,
//             education, real estate, and community living — each one designed to solve a real,
//             everyday problem for the people who use it.
//           </p>
//         </div>
//       </section>

//       {/* DOMAIN CHIPS */}
//       <div className="projects-domain-strip reveal-up">
//         {[
//           { label: "Government", id: "01" },
//           { label: "HRMS", id: "02" },
//           { label: "E-Commerce", id: "03" },
//           { label: "Transport Tracking", id: "04" },
//           { label: "Healthcare", id: "05" },
//           { label: "Community Services", id: "06" },
//           { label: "Trust & Church", id: "07" },
//           { label: "Real Estate", id: "08" },
//           { label: "Matrimony", id: "09" },
//         ].map((d) => (
//           <span
//             className={`projects-domain-chip${activeId === d.id ? " active" : ""}`}
//             key={d.label}
//             role="button"
//             tabIndex={0}
//             onClick={() => {
//               setActiveId(d.id);
//               const el = document.getElementById(`project-${d.id}`);
//               if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//             }}
//             onKeyDown={(e) => {
//               if (e.key === "Enter" || e.key === " ") {
//                 e.preventDefault();
//                 setActiveId(d.id);
//                 const el = document.getElementById(`project-${d.id}`);
//                 if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//               }
//             }}
//           >
//             {d.label}
//           </span>
//         ))}
//       </div>

//       {/* ALTERNATING PROJECTS */}
//       <div className="projects-container">
//         {PROJECTS.map((project, index) => {
//           const isActive = activeId === project.id;
//           const isEven = index % 2 === 0;

//           return (
//             <div
//               className={`project-section reveal-up ${isActive ? "active" : ""}`}
//               key={project.id}
//               id={`project-${project.id}`}
//             >
//               <div className={`project-section-inner ${isEven ? "" : "reverse"}`}>
//                 {/* IMAGE COLUMN */}
//                 <div className="project-image-column">
//                   <img src={project.image} alt={project.name} loading="lazy" />
//                   <div className="project-image-overlay" />
//                   <span className="project-type-badge">{project.type}</span>
//                 </div>

//                 {/* CONTENT COLUMN */}
//                 <div
//                   className="project-content-column"
//                   onClick={() => setActiveId(isActive ? null : project.id)}
//                 >
//                   <p className="project-domain-label">{project.domain}</p>
//                   <h2 className="project-title">{project.name}</h2>
//                   <p className="project-description">{project.description}</p>

//                   <div className="project-tags">
//                     {project.tags.map((tag) => (
//                       <span className="project-tag" key={tag}>{tag}</span>
//                     ))}
//                   </div>

//                   <button
//                     className="project-toggle-btn"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setActiveId(isActive ? null : project.id);
//                     }}
//                   >
//                     <span>{isActive ? "Show Less" : "Read More"}</span>
//                     <span className="project-toggle-arrow">↓</span>
//                   </button>

//                   {project.websites && project.websites.length > 0 && (
//                     <div className="project-websites-container">
//                       {project.websites.map((site, idx) => (
//                         <a 
//                           key={idx}
//                           href={site.url} 
//                           target="_blank" 
//                           rel="noreferrer"
//                           className="project-visit-btn"
//                         >
//                           <span>🌐 Visit {site.label}</span>
//                         </a>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* CTA STRIP */}
//       <div className="projects-cta-strip">
//         <h2>Ready to Build Your Next Project?</h2>
//         <p>
//           Let's collaborate to transform your ideas into innovative solutions that drive
//           real impact for your business and your users.
//         </p>
//         <NavLink to="/Services" className="projects-cta-btn">
//           Explore Services
//         </NavLink>
//       </div>

//       {/* FOOTER */}
//       <footer className="tunga-footer">
//         <div className="tunga-footer-content">
//           <div className="tunga-footer-col reveal-left">
//             <h3>Bliss Sierra</h3>
//             <p>We are committed to delivering the best services for your business.</p>
//           </div>
//           <div className="tunga-footer-col reveal-up">
//             <h3>Quick Links</h3>
//             <NavLink to="/">Home</NavLink><br/>
//             <NavLink to="/Tunga-Drones">Tunga Drones</NavLink><br/>
//             <NavLink to="/Our-Projects">Our Projects</NavLink><br/>
//             <NavLink to="/Services">Services</NavLink><br/>
//             <NavLink to="/Careers">Careers</NavLink><br/>
//             <NavLink to="/OurTeam">Our Core Team</NavLink>
//           </div>
//           <div className="tunga-footer-col reveal-right">
//             <h3>Contact</h3>
//             <p>📍 Neelakanta Nilayam, Kakateeya Hiils, Road No 9, Madhapur, Hyderabad-500081</p>
//             <p>📧 contact@blisssierra.com</p>
//             <p>📞 +91-7702232247</p>
//             <div className="tunga-social-links">
//               <a href="https://www.facebook.com/profile.php?id=61584931498008" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebookF /></a>
//               <a href="https://www.instagram.com/blisssierra1/" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
//               <a href="https://www.linkedin.com/feed/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
//               <a href="https://wa.me/917702232247" target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
//             </div>
//           </div>
//         </div>
//         <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: "30px", textAlign: "center", color: "rgba(255,255,255,0.6)" }}>
//           <p>&copy; 2026 Bliss Sierra. All rights reserved.</p>
//         </div>
//       </footer>
//     </div>
//   );
// }

// export default OurProjects;  


























import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";

import bslogo from "./assets/companylogo.png";
import ThreeD from "./ThreeD";
import image1 from "./assets/opimage1.png";
import image2 from "./assets/opimage2.png";
import image3 from "./assets/opimage3.png";
import image4 from "./assets/opimage4.png";
import image5 from "./assets/opimage5.png";
import image6 from "./assets/opimage6.png";
import image8 from "./assets/opimage8.png";
import image9 from "./assets/opimage9.png";

const PROJECTS = [
  {
    id: "01",
    name: "CM Cheyutha",
    domain: "Government Services",
    type: "Mobile Application",
    image: image1,
    description:
      "CM Cheyutha is a large-scale citizen-services platform built to meet AP and Telangana Government requirements. It lets citizens raise problems, report crimes, and file grievances through dedicated pages, then track each request to resolution. The app runs MLA and MP perception surveys to capture public feedback at the constituency level. Residents can browse government services, view bills, and complete payments inside a single secure flow. A powerful admin layer gives officials live monitoring, status updates, and reporting. The result is a transparent bridge between citizens and the government that reduces paperwork, speeds up responses, and keeps every interaction accountable from submission to closure.",
    tags: ["Grievance Portal", "Surveys", "Bills & Payments", "Admin Monitoring"],
  },
  {
    id: "02",
    name: "Employee Desk (HRMS)",
    domain: "HR & Employee Management",
    type: "Mobile Application",
    image: image2,
    description:
      "Employee Desk is a complete HRMS that brings every people-operation into one connected workspace. It maintains accurate employee records, tracks daily attendance, and manages the full leave lifecycle from request to approval. Multi-level approval chains keep managers and HR aligned, while built-in internal communication keeps teams informed without scattered emails. Detailed reports turn raw activity into insight on attendance trends, leave balances, and workforce performance. Role-based access ensures employees, managers, and HR each see exactly what they need. By replacing spreadsheets and manual registers with a structured digital system, Employee Desk cuts administrative overhead and helps organisations run their HR and admin operations smoothly and reliably.",
    tags: ["Attendance", "Leave Management", "Approvals", "Reports"],
  },
  {
    id: "03",
    name: "Bizvora · Naarisamman · CityChoice Mart",
    domain: "E-Commerce / Marketplace",
    type: "Mobile + Web",
    image: image3,
    description:
      "This is a family of full-featured online shopping platforms delivered for multiple brands. Each storefront offers rich product listings organised into clear categories, making it easy for shoppers to discover what they need. A smooth cart and checkout flow handles orders end to end, while customer management keeps profiles, addresses, and history in order. Dedicated vendor and admin panels let sellers manage inventory and let operators oversee the whole marketplace. Promotional offers and discounts drive engagement, and live order tracking keeps buyers informed after purchase. Together these apps give each brand a scalable, branded commerce experience that supports growth from a handful of products to a busy multi-vendor catalog.",
    tags: ["Catalog", "Cart & Orders", "Vendor Panel", "Order Tracking"],
  },
  {
    id: "04",
    name: "Trace My Bus",
    domain: "Transport / School Bus Tracking",
    type: "Mobile Application",
    image: image4,
    description:
      "Trace My Bus is a real-time tracking solution built for schools and private fleet-management teams. Parents and administrators can follow each bus on a live map, see its position along the assigned route, and know when it will arrive. Route monitoring flags delays and deviations early, while driver details add a layer of trust and accountability for every trip. The platform is designed around student safety, giving schools a clear record of who is on board and where the vehicle is at all times. A central admin console manages routes, drivers, and vehicles in one place. The outcome is calmer mornings, fewer anxious calls, and safer journeys for every student.",
    tags: ["Live Location", "Route Monitoring", "Driver Details", "Student Safety"],
  },
  {
    id: "05",
    name: "MediQueue & Hospital Management System",
    domain: "Healthcare",
    type: "Mobile Application",
    image: image5,
    description:
      "MediQueue and the companion Hospital Management System digitise the everyday running of clinics and hospitals. Patients can book appointments or tokens, check doctor timings, and avoid long waits thanks to smart queue management. Comprehensive patient records keep medical history, visits, and prescriptions organised and accessible to authorised staff. The administration layer handles departments, schedules, and day-to-day hospital operations from one dashboard. Automated notifications remind patients of appointments and keep them updated, reducing no-shows. Detailed reports support better decisions on capacity and care. By replacing manual registers and crowded waiting rooms with an orderly digital flow, these apps improve the experience for patients while giving healthcare teams the control and visibility they need.",
    tags: ["Appointments", "Queue Management", "Patient Records", "Notifications"],
  },
  {
    id: "06",
    name: "Gated Community & All-in-One Services",
    domain: "Community / Services",
    type: "Mobile Application",
    image: image6,
    description:
      "This suite of apps modernises life in residential communities and apartment complexes. Visitor management screens and logs every guest, strengthening security at the gate. Residents can raise complaints, submit repair requests, and book everyday services without chasing anyone in person. Integrated payments make maintenance dues and service charges simple to settle online. Security and admin teams get dedicated tools to coordinate staff, track requests, and keep the community running smoothly. Notifications keep everyone informed about announcements and approvals. By combining visitor control, service bookings, complaints, and payments into one all-in-one platform, these apps reduce friction for residents and give management a clear, accountable view of every activity inside the community.",
    tags: ["Visitor Management", "Complaints", "Service Booking", "Security"],
  },
  {
    id: "07",
    name: "Trust, Church & Mission Apps",
    domain: "Service-Oriented Platforms",
    type: "Mobile + Web",
    image: "https://images.unsplash.com/photo-1438032005730-c779502df39b?auto=format&fit=crop&w=900&q=80",
    description:
      "Built for religious, trust, and mission-based organisations such as Bible apps, Swamy Vivekananda Mission Trust, and Delight Christian Church, these platforms keep communities connected. Administrators can publish content updates and share devotional or organisational material with members instantly. An events module announces gatherings and programmes, while a gallery preserves photos and memories from each occasion. Push notifications keep members informed about news and schedules. Secure donation features let supporters contribute easily and transparently. Member communication tools strengthen the bond between the organisation and its community. By bringing content, events, donations, and messaging into one respectful, easy-to-use app, these solutions help mission-driven organisations grow their reach and serve their members with care.",
    tags: ["Content Updates", "Events", "Gallery", "Donations"],
    websites: [
      { label: "Vivekananda Mission Trust", url: "https://vivekanandamissiontrust.com/" },
      { label: "Church Portal", url: "https://divinelightchristianassemblychurch.com/" }
    ]
  },
  {
    id: "08",
    name: "Real Estate Project",
    domain: "Real Estate / Property Management",
    type: "Mobile + Web",
    image: image8,
    description:
      "This real-estate solution covers the entire property journey for developers and agencies. It presents ventures and projects with detailed listings, layouts, and plot or flat information so buyers can explore options clearly. Prospects can schedule site visits and move into bookings without losing momentum. Payment tracking keeps every instalment and milestone transparent for both customer and company. Customer management organises leads and clients, while employee roles assign the right access to sales and support staff. Comprehensive admin dashboards give leadership a real-time view of inventory, bookings, and revenue. By unifying listings, visits, bookings, payments, and reporting, the platform streamlines sales and brings order and confidence to property transactions.",
    tags: ["Listings", "Site Visits", "Bookings", "Dashboards"],
  },
  {
    id: "09",
    name: "Matrimony — All & Christian Community",
    domain: "Matrimony / Community Platform",
    type: "Mobile Application",
    image: image9,
    description:
      "These matrimony platforms serve both all-community and Christian-community users with a safe, structured path to finding a life partner. Members create detailed profiles and use powerful search and match features to discover compatible candidates. Interest requests let users express intent respectfully, while admin approval keeps the community trustworthy and free of fake profiles. Built-in chat and contact controls protect privacy until both sides are comfortable connecting. Clear membership workflows guide users from registration through to premium plans. Administrators oversee verification, approvals, and member activity from a central panel. By balancing rich matching tools with careful moderation and privacy, these apps deliver a dignified, community-focused matrimony experience that families can rely on.",
    tags: ["Profiles", "Search & Match", "Interest Requests", "Membership"],
  },
];

function OurProjects() {
  const [navScrolled, setNavScrolled] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setNavScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const revealTargets = document.querySelectorAll(".reveal-up, .reveal-left, .reveal-right");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.12 }
    );
    revealTargets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="projects-page">
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        :root {
          --accent: #a3e635;
          --accent-2: #bef264;
          --accent-deep: #84cc16;
          --text-main: #eef2f7;
          --text-soft: #94a3b8;
          --heading-font: "Cinzel", serif;
          --body-font: "Manrope", sans-serif;
        }
        html, body { cursor: auto !important; }
        input, textarea { cursor: text !important; caret-color: #a3e635; }
        button, a, select { cursor: pointer !important; }
        html { scroll-behavior: smooth; }
        body { font-family: var(--body-font); color: var(--text-main); background: #0a0e1a; }

        .projects-page { position: relative; min-height: 100vh; overflow: hidden; }

        /* NAVBAR */
        .projects-navbar {
          position: sticky;
          top: 0;
          z-index: 1000;
          background: rgba(19, 26, 44, 0.88);
          backdrop-filter: blur(16px);
          border-bottom: 1px solid rgba(163, 230, 53,0.12);
          box-shadow: 0 8px 28px rgba(15,23,42,0.05);
          transition: box-shadow 0.4s ease, background 0.4s ease;
          will-change: background, box-shadow;
          transform: translateZ(0);
        }
        .projects-navbar.scrolled { background: rgba(19, 26, 44, 0.98); box-shadow: 0 12px 40px rgba(15,23,42,0.14); }

        .projects-nav-container {
          width: min(1220px, 92%);
          margin: 0 auto;
          padding: 14px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .projects-nav-logo {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .projects-nav-logo img {
          width: 54px;
          height: 54px;
          object-fit: contain;
          border-radius: 14px;
        }

        .projects-site-title {
          font-family: var(--heading-font);
          font-size: 1.45rem;
          font-weight: 800;
          letter-spacing: 1px;
          color: #eef2f7;
        }

        .projects-back-button {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: none;
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          color: #fff;
          font-size: 18px;
          cursor: pointer;
          box-shadow: 0 10px 24px rgba(163, 230, 53,0.22);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .projects-back-button:hover {
          transform: scale(1.12);
          box-shadow: 0 18px 38px rgba(163, 230, 53,0.35);
        }

        .projects-nav-links {
          display: flex;
          align-items: center;
          gap: 22px;
        }

        .projects-nav-links a {
          color: var(--text-soft);
          font-size: 0.96rem;
          font-weight: 700;
          text-decoration: none;
          transition: color 0.28s ease;
        }

        .projects-nav-links a:hover,
        .projects-nav-links a.active { color: var(--accent-deep); }

        .projects-nav-toggle {
          display: none;
          font-size: 1.8rem;
          color: #eef2f7;
          cursor: pointer;
        }

        /* HERO SECTION */
        .projects-hero {
          background: linear-gradient(135deg, rgba(163, 230, 53,0.1), rgba(163, 230, 53, 0.05));
          display: grid;
          place-items: center;
          text-align: center;
          padding: 70px 5% 50px;
        }

        .projects-hero-content h1 {
          font-family: var(--heading-font);
          font-size: clamp(2rem, 5vw, 3.5rem);
          color: var(--text-main);
          margin-bottom: 20px;
          letter-spacing: 1px;
          animation: slideInDown 0.8s ease-out;
        }

        .projects-hero-content p {
          font-size: 1.1rem;
          color: var(--text-soft);
          max-width: 760px;
          margin: 0 auto;
          line-height: 1.8;
          animation: fadeIn 0.8s ease-out 0.2s both;
        }

        /* DOMAIN CHIPS */
        .projects-domain-strip {
          width: min(1220px, 92%);
          margin: 0 auto 10px;
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: center;
          padding-bottom: 30px;
        }

        .projects-domain-chip {
          padding: 8px 18px;
          border-radius: 999px;
          background: rgba(163, 230, 53,0.07);
          border: 1px solid rgba(163, 230, 53,0.18);
          color: var(--accent-deep);
          font-size: 0.85rem;
          font-weight: 700;
          animation: slideUp 0.5s ease-out;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .projects-domain-chip:hover {
          background: rgba(163, 230, 53,0.15);
          border-color: var(--accent-deep);
          transform: translateY(-2px);
        }

        .projects-domain-chip.active {
          background: var(--accent-deep);
          border-color: var(--accent-deep);
          color: #0a0e1a;
          box-shadow: 0 8px 20px rgba(163, 230, 53,0.3);
        }

        /* ALTERNATING PROJECTS SECTION */
        .projects-container {
          width: min(1220px, 92%);
          margin: 30px auto 90px;
        }

        .project-section {
          margin-bottom: 80px;
          animation: fadeIn 0.8s ease-out;
          border: 1px solid rgba(163, 230, 53,0.18);
          border-radius: 26px;
          padding: 30px;
          background: #0a0e1a;
          transition: border-color 0.4s ease, box-shadow 0.4s ease;
          scroll-margin-top: 110px;
        }

        .project-section:hover {
          border-color: rgba(163, 230, 53,0.4);
          box-shadow: 0 16px 40px rgba(163, 230, 53,0.1);
        }

        .project-section.active {
          border-color: var(--accent-deep);
          box-shadow: 0 16px 40px rgba(163, 230, 53,0.18);
        }

        .project-section-inner {
          display: grid;
          grid-template-columns: 1.5fr 1fr;
          gap: 60px;
          align-items: center;
        }

        /* IMAGE COLUMN */
        .project-image-column {
          position: relative;
          overflow: hidden;
          border-radius: 22px;
          width: 100%;
          background: #131a2c;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .project-image-column img {
          width: 100%;
          height: auto;
          max-height: 460px;
          object-fit: contain;
          display: block;
          transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .project-image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0);
          transition: background 0.4s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          pointer-events: none;
        }

        .project-section.active .project-image-overlay {
          background: rgba(163, 230, 53,0.15);
        }

        .project-type-badge {
          position: absolute;
          bottom: 14px;
          right: 14px;
          background: var(--accent);
          color: #fff;
          font-size: 0.8rem;
          font-weight: 700;
          padding: 8px 16px;
          border-radius: 999px;
          z-index: 2;
          box-shadow: 0 8px 20px rgba(163, 230, 53,0.3);
        }

        /* CONTENT COLUMN */
        .project-content-column {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding: 40px;
          background: #131a2c;
          border-radius: 22px;
          transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          cursor: pointer;
          border: 2px solid transparent;
        }

        .project-section.active .project-content-column {
          background: linear-gradient(135deg, rgba(163, 230, 53,0.08), rgba(163, 230, 53, 0.04));
          border: 2px solid var(--accent);
          box-shadow: 0 0 0 12px rgba(163, 230, 53,0.08), 0 20px 50px rgba(163, 230, 53,0.15);
          transform: scale(1.02);
        }

        .project-content-column:hover {
          transform: translateY(-4px);
        }

        .project-section.active .project-content-column:hover {
          transform: scale(1.02) translateY(-4px);
        }

        .project-domain-label {
          font-size: 0.8rem;
          font-weight: 800;
          letter-spacing: 1.2px;
          color: var(--accent-deep);
          text-transform: uppercase;
          margin-bottom: 8px;
        }

        .project-title {
          font-family: var(--heading-font);
          font-size: 1.8rem;
          color: var(--text-main);
          line-height: 1.3;
          margin-bottom: 12px;
        }

        .project-title::after {
          content: "";
          display: block;
          width: 48px;
          height: 4px;
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          border-radius: 3px;
          margin-top: 10px;
        }

        .project-description {
          font-size: 1rem;
          color: var(--text-soft);
          line-height: 1.8;
          margin-bottom: 12px;
          max-height: 200px;
          overflow: hidden;
          transition: max-height 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .project-section.active .project-description {
          max-height: 1000px;
        }

        .project-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 16px;
        }

        .project-tag {
          font-size: 0.75rem;
          font-weight: 600;
          color: var(--accent-deep);
          background: rgba(163, 230, 53,0.1);
          padding: 6px 14px;
          border-radius: 999px;
          transition: all 0.3s ease;
          border: 1px solid rgba(163, 230, 53,0.2);
        }

        .project-tag:hover {
          background: rgba(163, 230, 53,0.2);
          border-color: var(--accent-deep);
          transform: translateY(-2px);
        }

        .project-toggle-btn {
          align-self: flex-start;
          margin-top: auto;
          background: none;
          border: none;
          color: var(--accent-deep);
          font-weight: 800;
          font-size: 0.95rem;
          cursor: pointer;
          padding: 0;
          display: flex;
          align-items: center;
          gap: 8px;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .project-toggle-btn:hover {
          color: var(--accent);
          transform: translateX(4px);
        }

        .project-toggle-arrow {
          display: inline-block;
          transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
          font-size: 1.2rem;
        }

        .project-section.active .project-toggle-arrow {
          transform: rotate(-180deg);
        }

        /* VISIT WEBSITE BUTTON */
        .project-websites-container {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 12px;
        }

        .project-visit-btn {
          align-self: flex-start;
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          border: none;
          color: #fff;
          font-weight: 700;
          font-size: 0.85rem;
          cursor: pointer;
          padding: 10px 20px;
          border-radius: 999px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          text-transform: uppercase;
          letter-spacing: 0.5px;
          text-decoration: none;
          box-shadow: 0 6px 16px rgba(163, 230, 53,0.25);
        }

        .project-visit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 24px rgba(163, 230, 53,0.35);
        }

        .project-visit-btn svg {
          width: 14px;
          height: 14px;
        }

        /* REVERSE LAYOUT */
        .project-section-inner.reverse {
          direction: rtl;
        }

        .project-section-inner.reverse > * {
          direction: ltr;
        }

        /* CTA STRIP */
        .projects-cta-strip {
          width: min(1220px, 92%);
          margin: 0 auto 90px;
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          border-radius: 26px;
          padding: 50px 5%;
          text-align: center;
          color: white;
          animation: slideUp 0.8s ease-out;
        }

        .projects-cta-strip h2 {
          font-family: var(--heading-font);
          font-size: clamp(1.5rem, 3vw, 2.2rem);
          margin-bottom: 14px;
        }

        .projects-cta-strip p {
          font-size: 1rem;
          opacity: 0.92;
          max-width: 560px;
          margin: 0 auto 26px;
          line-height: 1.7;
        }

        .projects-cta-btn {
          display: inline-block;
          padding: 14px 38px;
          background: #0a0e1a;
          color: var(--accent-deep);
          border-radius: 999px;
          font-weight: 800;
          text-decoration: none;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border: none;
          cursor: pointer;
          font-size: 0.95rem;
        }

        .projects-cta-btn:hover {
          transform: translateY(-4px);
          box-shadow: 0 16px 36px rgba(0,0,0,0.25);
        }

        /* FOOTER */
        .tunga-footer {
          background: linear-gradient(180deg, rgba(163, 230, 53, 0.08), #070a12 18%);
          color: white;
          padding: 60px 5%;
          margin-top: 0;
          border-top: 3px solid var(--accent);
        }

        .tunga-footer-content {
          width: min(1220px, 92%);
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 50px;
          margin-bottom: 40px;
        }

        .tunga-footer-col h3 {
          font-family: var(--heading-font);
          font-size: 1.3rem;
          margin-bottom: 20px;
          color: var(--accent-2);
        }

        .tunga-footer-col p, .tunga-footer-col a {
          font-size: 0.95rem;
          line-height: 1.8;
          color: rgba(255,255,255,0.8);
          text-decoration: none;
        }

        .tunga-footer-col a:hover { color: var(--accent-2); }

        .tunga-social-links {
          display: flex;
          gap: 12px;
          margin-top: 20px;
        }

        .tunga-social-links a {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(163, 230, 53,0.2);
          display: grid;
          place-items: center;
          transition: all 0.3s ease;
          color: var(--accent-2);
        }

        .tunga-social-links a:hover {
          background: var(--accent);
          color: white;
          transform: translateY(-4px);
        }

        /* ANIMATIONS */
        @keyframes slideInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .reveal-up {
          opacity: 0;
          transform: translateY(40px);
          animation: slideUp 0.8s ease-out forwards;
        }

        .reveal-left {
          opacity: 0;
          transform: translateX(-40px);
          animation: slideInLeft 0.8s ease-out forwards;
        }

        .reveal-right {
          opacity: 0;
          transform: translateX(40px);
          animation: slideInRight 0.8s ease-out forwards;
        }

        @keyframes slideInLeft {
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes slideInRight {
          to { opacity: 1; transform: translateX(0); }
        }

        /* TABLET / MEDIUM RESPONSIVE */
        @media (max-width: 1024px) {
          .project-image-column img {
            max-height: 400px;
          }
        }

        /* MOBILE RESPONSIVE */
        @media (max-width: 768px) {
          .projects-nav-toggle { display: block; }
          .projects-nav-links {
            position: absolute;
            top: 82px; right: 4%;
            width: 240px;
            display: none;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            padding: 20px;
            background: rgba(19, 26, 44, 0.98);
            border-radius: 18px;
            border: 1px solid rgba(163, 230, 53,0.14);
            box-shadow: 0 18px 40px rgba(15,23,42,0.12);
          }
          .projects-nav-links.active { display: flex; }
          
          .project-section-inner {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .project-section-inner.reverse {
            direction: ltr;
          }

          .project-image-column img {
            max-height: none;
          }

          .project-type-badge {
            bottom: 10px;
            right: 10px;
            font-size: 0.72rem;
            padding: 6px 12px;
          }

          .project-content-column {
            padding: 30px 20px;
          }

          .project-title {
            font-size: 1.4rem;
          }

          .projects-cta-strip { padding: 40px 6%; }

          .project-section {
            margin-bottom: 50px;
            padding: 18px;
          }
        }

        @media (max-width: 480px) {
          .project-section {
            padding: 14px;
          }

          .project-image-column {
            border-radius: 16px;
          }

          .project-content-column {
            padding: 24px 16px;
          }
        }
      `}</style>

      <ThreeD />

      {/* NAVBAR */}
      <header className={`projects-navbar${navScrolled ? " scrolled" : ""}`}>
        <div className="projects-nav-container">
          <div className="projects-nav-logo">
          
            <h1 className="projects-site-title">Our Projects</h1>
          </div>
          <div className="projects-nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>

          <nav className={`projects-nav-links${menuOpen ? " active" : ""}`}>
            <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
            <NavLink to="/Tunga-Drones" onClick={() => setMenuOpen(false)}>Tunga Drones</NavLink>
            <NavLink to="/Our-Projects" onClick={() => setMenuOpen(false)}>Our Projects</NavLink>
            <NavLink to="/Services" onClick={() => setMenuOpen(false)}>Services</NavLink>
            <NavLink to="/Careers" onClick={() => setMenuOpen(false)}>Careers</NavLink>
            <NavLink to="/OurTeam" onClick={() => setMenuOpen(false)}>Our Core Team</NavLink>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section className="projects-hero reveal-up">
        <div className="projects-hero-content">
          <h1>Our Projects</h1>
          <p>
            A showcase of platforms we've built across government services, healthcare, e-commerce,
            education, real estate, and community living — each one designed to solve a real,
            everyday problem for the people who use it.
          </p>
        </div>
      </section>

      {/* DOMAIN CHIPS */}
      <div className="projects-domain-strip reveal-up">
        {[
          { label: "Government", id: "01" },
          { label: "HRMS", id: "02" },
          { label: "E-Commerce", id: "03" },
          { label: "Transport Tracking", id: "04" },
          { label: "Healthcare", id: "05" },
          { label: "Community Services", id: "06" },
          { label: "Trust & Church", id: "07" },
          { label: "Real Estate", id: "08" },
          { label: "Matrimony", id: "09" },
        ].map((d) => (
          <span
            className={`projects-domain-chip${activeId === d.id ? " active" : ""}`}
            key={d.label}
            role="button"
            tabIndex={0}
            onClick={() => {
              setActiveId(d.id);
              const el = document.getElementById(`project-${d.id}`);
              if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setActiveId(d.id);
                const el = document.getElementById(`project-${d.id}`);
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
          >
            {d.label}
          </span>
        ))}
      </div>

      {/* ALTERNATING PROJECTS */}
      <div className="projects-container">
        {PROJECTS.map((project, index) => {
          const isActive = activeId === project.id;
          const isEven = index % 2 === 0;

          return (
            <div
              className={`project-section reveal-up ${isActive ? "active" : ""}`}
              key={project.id}
              id={`project-${project.id}`}
            >
              <div className={`project-section-inner ${isEven ? "" : "reverse"}`}>
                {/* IMAGE COLUMN */}
                <div className="project-image-column">
                  <img src={project.image} alt={project.name} loading="lazy" />
                  <div className="project-image-overlay" />
                  <span className="project-type-badge">{project.type}</span>
                </div>

                {/* CONTENT COLUMN */}
                <div
                  className="project-content-column"
                  onClick={() => setActiveId(isActive ? null : project.id)}
                >
                  <p className="project-domain-label">{project.domain}</p>
                  <h2 className="project-title">{project.name}</h2>
                  <p className="project-description">{project.description}</p>

                  <div className="project-tags">
                    {project.tags.map((tag) => (
                      <span className="project-tag" key={tag}>{tag}</span>
                    ))}
                  </div>

                  <button
                    className="project-toggle-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveId(isActive ? null : project.id);
                    }}
                  >
                    <span>{isActive ? "Show Less" : "Read More"}</span>
                    <span className="project-toggle-arrow">↓</span>
                  </button>

                  {project.websites && project.websites.length > 0 && (
                    <div className="project-websites-container">
                      {project.websites.map((site, idx) => (
                        <a 
                          key={idx}
                          href={site.url} 
                          target="_blank" 
                          rel="noreferrer"
                          className="project-visit-btn"
                        >
                          <span>🌐 Visit {site.label}</span>
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* CTA STRIP */}
      <div className="projects-cta-strip">
        <h2>Ready to Build Your Next Project?</h2>
        <p>
          Let's collaborate to transform your ideas into innovative solutions that drive
          real impact for your business and your users.
        </p>
        <NavLink to="/Services" className="projects-cta-btn">
          Explore Services
        </NavLink>
      </div>

      {/* FOOTER */}
      <footer className="tunga-footer">
        <div className="tunga-footer-content">
          <div className="tunga-footer-col reveal-left">
            <h3>Bliss Sierra</h3>
            <p>We are committed to delivering the best services for your business.</p>
          </div>
          <div className="tunga-footer-col reveal-up">
            <h3>Quick Links</h3>
            <NavLink to="/">Home</NavLink><br/>
            <NavLink to="/Tunga-Drones">Tunga Drones</NavLink><br/>
            <NavLink to="/Our-Projects">Our Projects</NavLink><br/>
            <NavLink to="/Services">Services</NavLink><br/>
            <NavLink to="/Careers">Careers</NavLink><br/>
            <NavLink to="/OurTeam">Our Core Team</NavLink>
          </div>
          <div className="tunga-footer-col reveal-right">
            <h3>Contact</h3>
            <p>📍 Neelakanta Nilayam, Kakateeya Hiils, Road No 9, Madhapur, Hyderabad-500081</p>
            <p>📧 contact@blisssierra.com</p>
            <p>📞 +91-7702232247</p>
            <div className="tunga-social-links">
              <a href="https://www.facebook.com/profile.php?id=61584931498008" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://www.instagram.com/blisssierra1/" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://www.linkedin.com/feed/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
              <a href="https://wa.me/917702232247" target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>
        </div>
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: "30px", textAlign: "center", color: "rgba(255,255,255,0.6)" }}>
          <p>&copy; 2026 Bliss Sierra. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default OurProjects;